import { find, pipe, propEq, propOr } from 'ramda';

import { type ImageAnswer } from './image-answer';
import { type ImageQuestionData } from './image-question';

type ImageAnswerSet = {
  answers: ImageAnswer[];
  previousStepCode: string;
};

export type ConnectedImageQuestionData = {
  __typename: 'ConnectedImageQuestionRecord';
  answerSets: ImageAnswerSet[];
} & Omit<ImageQuestionData, '__typename' | 'answers'>;

export const convertConnectedToImageQuestion = (
  previousStepCode: string | null,
  questionData: ConnectedImageQuestionData
): Omit<ImageQuestionData, '__typename'> => {
  const { answerSets, ...commonData } = questionData;

  const answers: ImageAnswer[] = pipe<
    [ImageAnswerSet[]],
    ImageAnswerSet | undefined,
    ImageAnswer[]
  >(
    find<ImageAnswerSet>(propEq('previousStepCode', previousStepCode)),
    propOr([], 'answers')
  )(answerSets);

  return { answers, ...commonData };
};

export const connectedImageQuestionFragment = `
  fragment connectedImageQuestionFragment on ConnectedImageQuestionRecord {
    answerSets {
      answers {
        ...imageAnswerFragment
      }
      previousStepCode
    }
    description {
      value
    }
    imageBorderColor {
      gradientName
    }
    question
  }
`;
